// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feature-centainer[data-v-5c1064d8]{background:#e5f8fa}.list-btn-large[data-v-5c1064d8]{border:1px solid #31afba;border-radius:20px;background:#fff;color:#31afba;transition:all .3s;height:40px;width:250px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
